import styles from './AiRecommendations.module.css';
import FadeImage from '../../../../shared/components/FadeImage';
import ScoreBar from './ScoreBar';
import { actorMeta } from './recommendationModel';

/** 추천 배우 한 줄: 순위 · 사진 · 이름 · 나이/키 · 총점 · 기준별 막대 · 추천 이유 */
export default function RecommendationRow({ actor, criteria, onOpen }) {
  const open = () => onOpen(actor);
  return (
    <li className={styles.rowItem}>
      <div
        className={styles.row}
        onClick={open}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }}
        tabIndex={0}
        role="button"
        aria-label={`${actor.rank}위 ${actor.name} 상세 보기`}
      >
        <span className={styles.rowRank}>{actor.rank}</span>
        <div className={styles.rowPhoto}>
          <FadeImage src={actor.photoUrl} alt={actor.name} size="thumb" placeholder="talent" style={{ borderRadius: 'inherit' }} />
        </div>
        <div className={styles.rowInfo}>
          <span className={styles.rowName}>{actor.name}</span>
          <span className={styles.rowMeta}>{actorMeta(actor)}</span>
        </div>
        <div className={styles.rowTotal}>
          {actor.total != null ? (
            <>
              <span className={styles.rowTotalValue}>{Math.round(actor.total)}</span>
              <span className={styles.rowTotalUnit}>점</span>
            </>
          ) : (
            <span className={styles.rowTotalNone}>—</span>
          )}
        </div>
        <div className={styles.rowBar}>
          <ScoreBar criteria={criteria} scores={actor.scores} />
        </div>
        {actor.reason && <p className={styles.rowReason}>{actor.reason}</p>}
      </div>
    </li>
  );
}
